<template>
  <!-- SHLOG -->
  <div>
    <div>
      <b-row lg="12" md="12" sm="12">
        <b-col lg="9" md="8" sm="12">
          <b-row>
            <h1>{{ $t("workflow.processField.processFilled") }}</h1>
          </b-row>
          <b-row>
            <b-col cols="0">
              <b-button size="sm" @click="showModal()">
                {{ $t("geral.createNew") }}
              </b-button>
            </b-col>
            <b-col cols="0" class="ml-2">
              <b-button size="sm" @click="showImportModal()">
                {{ $t("geral.import") }}
              </b-button>
            </b-col>
            <b-col cols="0" class="ml-2">
              <b-button size="sm" @click="layoutModal()">
                {{ $t("geral.importLayout") }}
              </b-button>
            </b-col>
            <b-col cols="0" class="ml-2">
              <b-button size="sm" @click="getAllFields()">
                {{ $t("workflow.processes.editColumns") }}
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-form-group
              :label="$t('geral.saveFilters')"
              label-for="saveFilter"
              class="labelSaveFilter mt-2"
            >
              <b-form-checkbox
                class="checkboxSaveFilter"
                id="saveFilter"
                v-model="filterApplied.saveFilter"
              ></b-form-checkbox>
            </b-form-group>
            <b-button size="sm" @click="cleanFilters()">
              {{ $t("geral.cleanFilters") }}
            </b-button>
          </b-row>
        </b-col>
        <b-col lg="3" md="4" sm="12" align="right">
          <base-calendar
            ref="baseCalendar"
            class="calendar"
            :dateStr.sync="calendarDate"
            @calendarFilter="calendarFilter"
            @onMounted="onCalendarMounted"
          >
          </base-calendar>
        </b-col>
      </b-row>
    </div>

    <!-- carregando informações da tabela -->
    <div v-if="isLoadingFilters && isLoadingFields">
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </div>
    <div v-else>
      <b-table
        class="nowrapActions kanban-board-card shLog"
        ref="table"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        responsive="sm"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
            <div>{{ loadingError }}</div>
          </div>
        </template>

        <template #head()="scope">
          <div v-if="scope.field.key != 'actions'">
            <workflow-filter
              class="filters"
              :labelName="scope.field.label"
              :fieldType="scope.field.type"
              :fieldId="scope.field.fieldId"
              :filter="getFilter(scope.field)"
              :dateOpt.sync="
                fields[getFieldIndex(scope.field.label)].optionFilterDate
              "
              :filterApplied="filterApplied"
            ></workflow-filter>
          </div>
          <div class="mt-1">
            {{ scope.label }}
          </div>
          <!-- <div>optionFilterDate: {{ scope.field.optionFilterDate }}</div> -->
          <!-- <div>index: {{ getFieldIndex(scope.field.label) }}</div> -->
        </template>

        <!-- <template slot="thead-top" slot-scope="{ fields }">
            <b-tr>
              <b-th
                v-for="field in fields"
                :key="field.filterKey"
                class="vertical-align"
              >
                <div v-for="filter in tableFilters.fields" :key="filter.label">
                  <div v-if="filter.label == field.label">
                    <workflow-filter
                      class="filters"
                      :labelName="field.label"
                      :fieldType="field.type"
                      :fieldId="field.fieldId"
                      :filter="filter"
                      :dateOpt.sync="field.optionFilterDate"
                      :filterApplied="filterApplied"
                    ></workflow-filter>
                    <div>field.optionFilterDate: field.optionFilterDate</div>
                  </div>
                </div>
              </b-th>
            </b-tr>
          </template> -->
        <template v-slot:cell(cliente)="data">
          <div class="td-limitado">
            {{ data.value }}
          </div>
        </template>

        <template v-slot:cell(viagens)="data">
          <a href="#" @click.prevent="downloadTripPlan(data.item)">
            <u>
              {{ data.item.viagem }}
              <i class="tim-icons icon-attach-87"></i>
            </u>
          </a>
        </template>

        <template v-slot:cell(Veículo)="data">
          <b-row>
            <b-col class="mt-1" cols="5">
              {{ data.item.Veículo }}
            </b-col>
            <b-col v-if="data.item.vehicleOccurrences != '0'" class="icons_div">
              <a
              href="#"
              @click.prevent="
                openWorkflowOccurrecesFilledModal(
                  data.item.vehicleValueId,
                  data.item.Veículo
                )
              "
            >
              <u>
                <i class="icon_style material-icons">report</i>
              </u>
            </a>
            </b-col>
          </b-row>          
        </template>

        <template v-slot:cell(Motorista)="data">
          <b-row>
            <b-col class="mt-1" cols="9">
              {{ data.item.Motorista }}
            </b-col>
            <b-col v-if="data.item.driverOccurrences != '0'" class="icons_div">
              <a
              class="icon_style"
              href="#"
              @click.prevent="
                openWorkflowOccurrecesFilledModal(
                  data.item.driverValueId,
                  data.item.Motorista
                )
              "
            >
              <u>
                <i class="material-icons">report</i>
              </u>
            </a>
            </b-col>
          </b-row>
          
        </template>

        <template v-slot:cell(id)="cell">
          <a
            href="#"
            @click.prevent="
              $refs.fillingDetails.show(
                cell.value,
                cell.item.stageId,
                cell.item.CanComment == 'True'
              )
            "
          >
            # <u>{{ cell.value }}</u>
          </a>
        </template>

        <template v-slot:cell(actions)="data">
          <!-- {{ data.item }} -->
          <b-button
            size="sm"
            :title="$t('geral.details')"
            @click="
              fillingDetails(
                data.item.Id,
                data.item.StatusId,
                data.item.CanComment == 'True'
              )
            "
          >
            <i>
              <b-icon icon="eye" aria-hidden="true"></b-icon>
            </i>
          </b-button>
        </template>
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
    </div>
    <!-- criar novo processo -->
    <workflow-fill-modal
      ref="fillModal"
      :id="processId"
      @refreshData="refreshTable"
    >
    </workflow-fill-modal>
    <!-- importar processo -->
    <workflow-import-modal
      ref="importModal"
      :processId="processId"
      @refreshData="refreshTable"
    >
    </workflow-import-modal>
    <!-- layout de importação -->
    <workflow-import-layout-modal ref="layoutImport" :processId="processId">
    </workflow-import-layout-modal>

    <!-- filtros -->
    <workflow-all-fields-modal
      ref="allFields"
      :processId="processId"
      :selectedFields="selectedFields"
      :selected.sync="selected"
      @refreshFilter="refreshFilter"
    ></workflow-all-fields-modal>

    <!-- detalhes do preenchimento -->
    <filling-details-modal
      ref="fillingDetails"
      :processName="processName"
      :permissions="permissions"
      @refreshData="refreshTable"
    ></filling-details-modal>

    <!-- occcrencias -->
    <workflow-occurreces-filled-modal
      ref="WorkflowOccurrecesFilledModal"
    ></workflow-occurreces-filled-modal>

    <!-- {{ permissions }} -->
    <!-- <pre class="language-json"><code>Filters: {{ allInformations }}</code></pre> -->
    <!-- <pre
        class="language-json"
      ><code>FiltersApplied: {{ filterApplied  }}</code></pre> -->
  </div>
</template>

<script>
export default {
  name: "ShlogProcessFilledList",
  props: {
    processId: String,
    processName: String,
  },
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    WorkflowAllFieldsModal: () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/WorkflowAllFieldsModal.vue"
      ),
    WorkflowFilter: () =>
      import("@/components_rms/workflow/WorkflowFilled/WorkflowFilter.vue"),
    WorkflowFillModal: () =>
      import("@/components_rms/workflow/WorkflowFillModal.vue"),
    WorkflowImportModal: () =>
      import("@/components_rms/workflow/WorkflowImportModal.vue"),
    WorkflowImportLayoutModal: () =>
      import("@/components_rms/workflow/WorkflowImportLayoutModal.vue"),
    FillingDetailsModal: () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/FillingDetailsModal.vue"
      ),
    BaseCalendar: () => import("@/components_rms/base/BaseCalendar.vue"),
    WorkflowOccurrecesFilledModal: () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/WorkflowOccurrecesFilledModal.vue"
      ),
  },
  created() {
    this.getFilters();
    this.getFields();
    this.getPermissions();
  },
  computed: {},
  data() {
    return {
      minhaCor: "suaCorPersonalizada",
      isBusy: false,
      isLoadingFields: true,
      isLoadingFilters: true,
      tableFilters: {
        fields: [],
      },
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          thStyle: { width: "70px", minWidth: "70px" },
          // tdClass: "checklist-filled-table-col-buttons",
        },
      ],
      values: [],
      allFields: [],
      selectedFields: [],
      selected: [],
      tableRowCount: 0,
      tablePerPage: 100,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      commentId: 0,
      commentStageId: 0,
      nextStatusId: 0,
      latitude: 0.0,
      longitude: 0.0,
      optionsActive: [
        { value: "", text: "Todos" },
        { value: "1", text: "Sim" },
        { value: "0", text: "Não" },
      ],
      permissions: {
        administrador: false,
        gestor: false,
        simpleOperator: false,
      },
      filterApplied: {
        pageUrl: "",
        saveFilter: true,
        appliedFilters: "",
        filterDateApplied: [],
      },
      tableFilterApplied: {},
      loadingError: "",
      calendarDate: null,
      allInformations: [],
    };
  },
  methods: {
    withOccurrences(value, processId) {
      let hasOccurrences = [];
      this.allInformations.forEach((item) => {
        if (processId == item.processFilledId && value == item.fieldValue) {
          if (item.occurrenceAmount != 0) {
            hasOccurrences.push(item);
          }
        }
      });
      return hasOccurrences;
    },
    openWorkflowOccurrecesFilledModal(processFilledId, value) {
      this.$refs.WorkflowOccurrecesFilledModal.show(processFilledId, value);
    },
    getFieldIndex(label) {
      for (let i = 0; i < this.fields.length; i++) {
        let field = this.fields[i];
        if (field.label == label) {
          return i;
        }
      }
      return 0;
    },
    getFilter(field) {
      for (let filter of this.tableFilters.fields) {
        if (filter.label == field.label) {
          return filter;
        }
      }
      return null;
    },
    //criar novo card
    showModal() {
      this.$refs.fillModal.show();
    },
    //importação de novos card
    showImportModal() {
      this.$refs.importModal.show();
    },
    //layout de importação
    layoutModal() {
      this.$refs.layoutImport.show();
    },
    //campos para os filtros
    getAllFields() {
      this.$refs.allFields.show();
    },
    //detalhes do preenchimentos
    fillingDetails(filledId, stageId, canComment) {
      this.$refs.fillingDetails.show(filledId, stageId, canComment);
    },
    refreshTable() {
      this.$refs.table.refresh();
    },

    getCalendarDate() {
      this.tableFilters.fields.forEach((field) => {
        if (field.label == "DATA INÍCIO") {
          this.calendarDate = field.value == "" ? null : field.value;
        }
      });

      // let today = new Date();
      // let year = today.getFullYear();
      // let month = today.getMonth() + 1;
      // let day = today.getDate();
      // this.tableFilters.fields.forEach((field) => {
      //   if (field.label == "DATA INÍCIO") {
      //     this.calendarDate =
      //       field.value == "" ? year + "-" + month + "-" + day : field.value;
      //   }
      // });
    },
    calendarFilter() {
      // console.log("calendarFilter");
      // console.log(this.calendarDate);
      this.tableFilters.fields.forEach((field) => {
        // console.log(field);
        if (field.label == "DATA INÍCIO") field.value = this.calendarDate ?? "";
      });
      this.$forceUpdate();
    },
    myProvider(ctx, callback) {
      if (this.isLoadingFilters) {
        this.isBusy = false;
        this.tableRowCount = 0;
        return [];
      }

      ctx.filter.fields.forEach((element) => {});
      this.isBusy = true;
      let items = [];
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        fields: ctx.filter.fields,
      };
      this.$apiWorkflow
        .post("/processFilled/getAllCustomSh/" + this.processId, apiParam)
        .then((response) => {
          // console.log(response.data.items);
          items = response.data.items;
          let r = [];
          items.forEach((item) => {
            var obj = new Object();
            item.itens.forEach((value) => {
              this.allInformations.push(value);
              let fieldName = value.fieldName;
              let fieldValue = value.fieldValue;
              obj[fieldName] = fieldValue;
            });

            r.push(obj);
          });
          this.tableRowCount = response.data.totalItems;
          this.saveFilterApplied();
          this.getCalendarDate();
          callback(r);
        })
        .catch((error) => {
          // console.log(error);
          // console.log(error.response);
          console.log(error.response.data);
          this.loadingError = "Erro: " + error.response.data.detail;
          this.$forceUpdate();
          console.log(this.loadingError);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          }
        });
    },
    getFields() {
      // console.log("getFields");
      this.$apiWorkflow
        .get("/field/getSelected/" + this.processId)
        .then((response) => {
          if (response.data != "") {
            this.selectedFields = response.data;
          }
          this.isLoadingFields = false;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            if (error.response.data) {
              console.log(error.response.data.errors);
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
          }
          this.isLoadingFields = false;
          this.$forceUpdate();
        });
    },
    async saveFilterApplied() {
      this.filterApplied.pageUrl = window.location.href;
      let stringFilter = JSON.stringify(this.tableFilters);
      if (this.filterApplied.saveFilter == true) {
        this.filterApplied.appliedFilters = stringFilter;
        this.$apiWorkflow
          .post("/fitlerApplied/saveFilters/", this.filterApplied)
          .then((response) => {
            let model = JSON.parse(response.data.appliedFilters);
            this.tableFilters = model;
            // console.log("model");
            // console.log(model);
            this.filterApplied.appliedFilters = response.data.appliedFilters;
          });
      }
    },
    getFilters() {
      this.filterApplied.pageUrl = window.location.href;
      // console.log(this.filterApplied);
      this.$apiWorkflow
        .post("/customFilter/tableFilter/" + this.processId, this.filterApplied)
        .then((response) => {
          if (response.data != null) {
            let fields = response.data.fields;
            let filters = response.data.filters;
            // console.log("filters");
            // console.log(filters);
            let hasDateInit = false;

            fields.forEach((field) => {
              field.thStyle = "vertical-align: bottom !important";
              this.fields.push(field);
            });
            filters.forEach((filter) => {
              if (filter.label == "DATA INÍCIO") {
                hasDateInit = true;
                filter.value = this.getToday();
                this.tableFilters.fields.push(filter);
              } else {
                this.tableFilters.fields.push(filter);
              }
            });

            if (!hasDateInit) {
              this.fields.push({
                label: "DATA INÍCIO",
                optionFilterDate: 0,
                sortable: false,
                type: "2",
                fieldId: "",
                thStyle: "vertical-align: bottom !important",
              });
              this.tableFilters.fields.push({
                label: "DATA INÍCIO",
                value: this.getToday(),
              });
            }
            this.getCalendarDate();
          }
          this.isLoadingFilters = false;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            if (error.response.data) {
              console.log(error.response.data.errors);
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
          }
          this.isLoadingFilters = false;
          this.$forceUpdate();
        });
    },
    cleanFilters() {
      // // console.log("Clean Filter");
      this.tableFilters.fields.forEach((field) => {
        field.value = "";
      });
      this.fields.forEach((field) => {
        field.optionFilterDate = 0;
      });
      this.$refs["baseCalendar"].setToday();
      this.saveFilterApplied();
      this.getCalendarDate();
      this.$forceUpdate();
    },
    downloadTripPlan(data) {
      this.$apiWorkflow
        .request({
          url: "/path/print/" + data.Id,
          method: "POST",
          data: data,
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    getPermissions() {
      this.$apiWorkflow
        .get("/customFilter/GetPerimissions/" + this.processId)
        .then((response) => {
          this.permissions = response.data;
        });
    },
    onCalendarMounted() {
      this.$refs["baseCalendar"].setToday();
      this.tableFilters.fields.forEach((field) => {
        if (field.label == "DATA INÍCIO") {
          this.calendarDate = field.value == "" ? null : field.value;
        }
      });
    },
    refreshFilter() {
      this.$refs.table.refresh();
      this.tableFilters.fields = [];
      this.fields = [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "nowrapActions",
        },
      ];
      this.getFilters();
      this.getFields();
    },
  },
  watch: {
    processId() {
      // console.log("Entrou");
      // console.log(this.tableFilters);
      this.tableFilters.fields = [];
      this.fields = [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "nowrapActions",
        },
      ];
      this.getFilters();
      this.getFields();
    },
    calendarDate() {
      if (!this.calendarDate) return;
      if (this.calendarDate == null) return;

      let today = new Date();
      let year = today.getFullYear();
      let month = today.getMonth() + 1;
      let day = today.getDate();

      const date = this.calendarDate.split("-");

      let yearStr = parseInt(date[0]);
      let monthStr = parseInt(date[1]);
      let dayStr = parseInt(date[2]);
      if (year != yearStr && month != monthStr && day != dayStr) {
        this.fields.forEach((field) => {
          if (field.type == "2" && field.label == "DATA INÍCIO") {
            field.optionFilterDate = 0;
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.icon_style {
  color: #ec5353;
  margin-top: auto;
  margin-bottom: auto;
}

.table-width {
  min-width: 600px;
}

.labelSaveFilter {
  border-bottom-width: 1px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
  border: 0;
  color: hsla(0, 0%, 100%, 0.7);
}

.checkboxSaveFilter {
  margin-left: 105px;
  margin-top: -28px;
}

.checklist-filled-table-col-buttons {
  width: 90px;
}

.vertical-align {
  vertical-align: bottom !important;
}

.calendar {
  max-width: 305px !important;
}
</style>

<style>
.td-limitado {
  max-width: 250px !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}

.td-limitado:hover {
  overflow: visible !important;
  white-space: initial !important;
}
</style>